<mat-form-field class="custom-width-mat-picker large search-form-field" [class]="customWidth">
    <mat-label>{{ label }}</mat-label>
    <mat-select 
      [value]="value"
      [disabled]="disabled"
      (valueChange)="valueChange.emit($event)"
      (closed)="onClosed()"
      >
        <mat-option class="input-option">
            <mat-form-field appearance="outline" class="search-form-field" (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()">
                <mat-label (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    Search {{ label }}
                </mat-label>
                <input matInput
                 [formControl]="searchControl"
                 (click)="$event.stopPropagation()"
                 (keydown)="$event.stopPropagation()"
                 autocomplete="off" />
            </mat-form-field>
        </mat-option>
        <mat-option *ngFor="let opt of filteredOptions$ | async" [value]="opt[valueKey]">
            {{ getDisplay(opt) }}
        </mat-option>
    </mat-select>
</mat-form-field>  